import { render, staticRenderFns } from "./Partie14.vue?vue&type=template&id=08dd484a&"
import script from "./Partie14.vue?vue&type=script&lang=js&"
export * from "./Partie14.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports